export enum InvitationDocsExportType {
  WorkplaceRisks = 'WORKPLACE_RISKS',
  ActivityRisks = 'ACTIVITY_RISKS',
  Attachment = 'ATTACHMENT',
}
